import { getTemplate, registerPartial, ControlTemplate } from 'dac-web-ui';
import html from '../../templates/questionform.module.hbs'; 

import css from '../../css/initform.module.css';
import { Rules } from '../rules.js';



export class QuestionFormManager extends ControlTemplate {
	constructor( modules, managers ) {
		super();
		this.modules = modules;
		this.managers = managers;
		this.managers.QuestionFormManager = this;
		this.data = [];
		this.currentQuestions={};

		//add css
		this._addStyle( 'initFormStyle', css );
		this.init();
	}

	init() {
		this.data = this.managers.DataManager.data.preguntas;
	}	
	update(aquaData){
		this.data = this.managers.DataManager.data.preguntas;
		let questions=[];
		console.log(aquaData);
		if (aquaData==null){
			questions=[
				{
					label:"Normales",
					data:this._setPreguntas(this.managers.AquaManager.gridAqua, Rules.getOpcionesNormales( this.data ))
				}
			];
		}else if (aquaData.type=='capillas'){
			questions=[
				{
					label:"Capilla",
					data:this._setPreguntas(aquaData, Rules.getOpcionesCapilla( this.data ))
				}
			];
		}else if (aquaData.type=='traversales'){
			questions=[
				{
					label:"Traversales",
					data:this._setPreguntas(aquaData, Rules.getOpcionesTransversales( this.data ))
				}
			];
		}else if (aquaData.type=='laterales'){
			questions=[
				{
					label:"Laterales",
					data:this._setPreguntas(aquaData, Rules.getOpcionesLateral( this.data ))
				}
			];
		}else if (aquaData.type=='frontales'){
			questions=[
				{
					label:"Frontales",
					data:this._setPreguntas(aquaData, Rules.getOpcionesFrontalNorte( this.data ))
				}
			];
		}else if (aquaData.type=='zonas'){
			questions=[
				{
					label:"Zonas",
					data:this._setPreguntas(aquaData, Rules.getOpcionesZona( this.data ))
				}
			];
		}
		this.currentQuestions=structuredClone(questions[0].data);
		if(aquaData){
			aquaData.aqua.questions=this.currentQuestions;
		}else if(this.managers.AquaManager.gridAqua!=null){
			this.managers.AquaManager.gridAqua.aqua.questions=this.currentQuestions;
		}
		const body = getTemplate(questions, html);
		const container= document.querySelector('#questionsForm');
		container.innerHTML = body;
		this._addHandlers(container);		
	}
	_setPreguntas(aquaData , data){
		if (aquaData==null || aquaData.aqua.questions==null){
			return this._orderData(data);
		}else{
			return aquaData.aqua.questions;
		}
	}
	_orderData(data){
		let grupo='';
		data=data.sort((a,b) => a.grupo.localeCompare(b.grupo));
		let orderedData=[];
		data.forEach( (obj) => {
			if (obj.grupo!=grupo){
				grupo=obj.grupo;
				orderedData.push({name:grupo, questions:[obj]});
			}else{
				orderedData[orderedData.length-1].questions.push(obj);
			}
		});
		return orderedData;
	}
	_addHandlers(container) {
		container.querySelectorAll('.questionCombo').forEach( (questionCombo) => {
			questionCombo.addEventListener('change', (event) => {
				let eventData = event.target.dataset;
				eventData.value = event.target.value;
				this._setResponse(eventData);
				//this.publish('questionComboChange', eventData);
			});
		});
		container.querySelectorAll('.questionSectionTitle').forEach( (questionCombo) => {
			questionCombo.addEventListener('click', (event) => {
				let sectionBody=document.querySelector('.questionSectionBody[data-section="'+event.target.dataset.section+'"]');
				if(sectionBody.dataset.hide=='expandHeight'){
					sectionBody.dataset.hide='dexpandHeight';
				}else{
					sectionBody.dataset.hide='expandHeight';
				}
			});
		});
	}	
	_setResponse(data){
		this.currentQuestions.forEach( (section) => {
			section.questions.forEach( (question) => {
				if (question.id==data.idpregunta){
					question.CABOPTDefecto=question.CABOPTOpciones.find( (option) => option.id==data.value);
				}
			});
		});
	}

}